
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("timetable/timetable_empty",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div style=\"text-align:center;max-width:400px;margin:0 auto 48px auto;\"><div class=\"timetable-empty\"></div><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"timetable.emptytitle",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":111},"end":{"line":1,"column":144}}})) != null ? stack1 : "")
    + "</h1><p class=\"sub4 blockmargin\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"timetable.emptytext",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":177},"end":{"line":1,"column":209}}})) != null ? stack1 : "")
    + "</p><button data-fw-onclick=\"timetablepickcreate\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"timetable.create",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":260},"end":{"line":1,"column":289}}})) != null ? stack1 : "")
    + " </button></div> ";
},"useData":true});
export default TPL;